import styled from 'styled-components';

const Label = styled.label`
   color: #666666;
   font-size: 14px;
   line-height: 20px;
`;

export default Label;